export const classes = {
  wrapper: 'relative size-full overflow-hidden bg-grey-3 dark:bg-white/[0.05]',
  canvas: 'size-full',
};
